const TRUE_VALUES = new Set(['1', 'true', 'yes', 'on'])

export const parseFeatureFlag = (value, defaultValue = false) => {
  if (value == null || String(value).trim() === '') {
    return defaultValue
  }

  return TRUE_VALUES.has(String(value).trim().toLowerCase())
}

export const isPlanetHdV1Enabled = () =>
  parseFeatureFlag(process.env.REACT_APP_PLANET_HD_V1_ENABLED, false)

export const isCopilotEnabled = () =>
  parseFeatureFlag(process.env.REACT_APP_COPILOT_ENABLED, false)

export const PLANET_HD_V1_ENABLED = isPlanetHdV1Enabled()
export const COPILOT_ENABLED = isCopilotEnabled()
